'use client';

import type { Results } from 'payments-lib-types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getDetailedPaymentsErrorText } from '@/helpers/payment';
import { showTooltip } from '@/helpers/tooltip';
import { useGetCommonStore } from '@/store';
import { TooltipTypes } from '@/store/tooltipStore';

interface ISubmitResult extends Results.SubmitResult {
  type: string;
}

export const useErrorsNotifications = (submitData?: ISubmitResult) => {
  const { t } = useTranslation('deposits');
  const useCommonStore = useGetCommonStore();

  const user = useCommonStore.use.user();

  useEffect(() => {
    console.log('[PAYMENTS-LIB] response:', submitData);
    if (submitData?.type === 'params_error') {
      getDetailedPaymentsErrorText(submitData, t, user?.currency);
    }

    if (submitData?.type === 'request_error') {
      showTooltip({
        type: TooltipTypes.ERROR,
        body: submitData.message,
        removeTimeout: 10_000,
      });
    }
  }, [submitData, t, user?.currency]);
};
